var _path, _path2, _polygon, _path3, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsultation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 655.359,
    height: 655.359,
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 6827 6827",
    id: "consultation",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "nonzero",
    d: "M4717 4006l0-146c0-587 933-587 933 0l0 157c-5 302-219 541-475 536-254-5-457-249-457-548zM5436 4619l-63-27c-31 24-97 94-128 124l0 480-60 60-60-60 0-479c-32-32-98-99-131-124-129 53-169 66-299 98-153 37-267 65-279 238l-42 620 1618 0-42-620c-17-247-251-199-515-310zM1177 1823l0-146c0-587 933-587 933 0l0 157c-5 302-219 541-475 536-254-5-457-249-457-548zM1896 2437l-63-27c-31 24-97 94-128 124l0 480-60 60-60-60 0-479c-32-32-98-99-131-124-129 53-169 66-299 98-153 37-267 65-279 238l-42 620 1618 0-42-620c-17-247-251-199-515-310z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M3676 5091c85,-21 172,32 193,118 21,85 -32,172 -118,193 -80,19 38,-5 -44,4 -927,111 -1815,-418 -2156,-1289l288 -137c3,6 6,12 9,19 288,737 1038,1184 1821,1090 69,-8 -61,19 6,3z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#333",
    points: "3623 5662 3623 4831 4038 5246"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M3157 1738c-84,27 -174,-20 -201,-104 -27,-84 20,-174 103,-201 78,-25 -37,8 43,-7 917,-178 1840,286 2244,1130l-278 157c-4,-6 -7,-12 -10,-18 -340,-714 -1121,-1106 -1895,-955 -68,13 60,-23 -6,-2z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#333",
    points: "3168 1165 3228 1994 2784 1609"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultation);
export default __webpack_public_path__ + "static/media/consultation.8c949d95256d22f610a2313d5b46c653.svg";
export { ForwardRef as ReactComponent };